import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';
import { UpgradeDialogComponent, UpgradeDialogData } from '../../shared/components/upgrade-dialog/upgrade-dialog.component';
import { PlanLimitError } from '../models/plan.model';

@Injectable()
export class PlanLimitInterceptor implements HttpInterceptor {
  private isDialogOpen = false;

  constructor(private dialog: MatDialog) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 402 && error.error?.code === 'PLAN_LIMIT_REACHED') {
          if (error.error?.limitType === 'archivedClient') {
            this.showArchivedClientDialog();
          } else {
            this.showUpgradeDialog(error.error as PlanLimitError);
          }
        }
        return throwError(() => error);
      })
    );
  }

  private showUpgradeDialog(limitError: PlanLimitError): void {
    if (this.isDialogOpen) return;
    this.isDialogOpen = true;

    const dialogData: UpgradeDialogData = {
      limitType: limitError.limitType,
      currentCount: limitError.currentCount,
      maxAllowed: limitError.maxAllowed
    };

    const dialogRef = this.dialog.open(UpgradeDialogComponent, {
      width: '400px',
      data: dialogData,
      disableClose: false
    });

    dialogRef.afterClosed().subscribe(() => {
      this.isDialogOpen = false;
    });
  }

  private showArchivedClientDialog(): void {
    if (this.isDialogOpen) return;
    this.isDialogOpen = true;

    const dialogData: UpgradeDialogData = {
      limitType: 'archivedClient',
      currentCount: 0,
      maxAllowed: 0
    };

    const dialogRef = this.dialog.open(UpgradeDialogComponent, {
      width: '400px',
      data: dialogData,
      disableClose: false
    });

    dialogRef.afterClosed().subscribe(() => {
      this.isDialogOpen = false;
    });
  }
}
